import Logs from './components';

export default Logs;
